export const formatBlank = (value, defaultValue) => {
  return value || defaultValue || '---';
};
